import React from 'react';
import {Badge, CrossSmallIcon, FlexItem} from '@genestack/ui';
import classNames from 'classnames';
import {useRemoveTagMutation} from './requests/use-remove-tag-mutation';
import styles from './tag.module.css';

interface Props {
    tag: string;
    isPrivate: boolean;
    accession: string;
    removable?: boolean;
}

export function Tag({tag, isPrivate, accession, removable}: Props) {
    const removeTagMutation = useRemoveTagMutation();

    return (
        <FlexItem>
            <Badge
                intent={isPrivate ? 'warning' : 'default'}
                ghost={isPrivate}
                contentProps={{
                    className: classNames(styles.tagBadge, {[styles.removable]: removable})
                }}
            >
                {tag}
                {removable && (
                    <CrossSmallIcon
                        className={classNames(styles.crossIcon, {[styles.warning]: isPrivate})}
                        onClick={() => removeTagMutation.mutate({tag, isPrivate, accession})}
                    />
                )}
            </Badge>
        </FlexItem>
    );
}
